import React from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import {
  ProductPod,
  PodSticker,
  ProductATC,
  ProductRating,
  ProductSample,
  ProductServiceAddOns,
  ProductIdentifier, ProductBadge, ProductSponsored,
  ProductImage, PodFooter, PodSection, ProductCompare,
  ProductCustomOptions, PodSpacer
} from '@thd-olt-component-react/product-pod';
import { ProductSeeSimilarItems } from '@thd-olt-component-react/product-pod-group';
import { Favorite } from '@thd-olt-component-react/save-to-favorites';
import { KeyProductFeatures } from '@thd-olt-component-react/key-product-features';
import { FulfillmentPodShipping, FulfillmentPodStore } from '@thd-olt-component-react/fulfillment';
import { SuperSkuMiniSwatches } from '@thd-olt-component-react/super-sku';
import { Price } from '@thd-olt-component-react/price';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { NonBuyableQuoteCenter } from '@thd-olt-component-react/non-buyable-quote-center';

export const CustomProductPod = ({
  itemId,
  storeId,
  position,
  onHover,
  onClick,
  hoverDelay,
  onCompare,
  onSelectedForCompare,
  selectedForCompare,
  itemRecsIndex,
  hasInStoreFilter
}) => {
  return (
    <ProductPod
      itemId={itemId}
      onHover={onHover}
      hoverDelay={hoverDelay}
      storeId={storeId}
      analyticsData={{ parent: 'plp', position }}
      render={(pod) => (
        <>
          <PodSticker position="top-left">
            <ProductBadge itemId={pod.itemId} storeId={storeId} />
            <ProductSponsored itemId={pod.itemId} position={position} />
          </PodSticker>
          <PodSticker position="top-right">
            <PodSpacer padding={['TOP', 'RIGHT']}>
              <Favorite itemId={pod.itemId} showCount showCircle />
            </PodSpacer>
          </PodSticker>
          <ProductImage
            itemId={pod.itemId}
            showSecondaryImage={pod.showSecondaryImage}
            onClick={onClick}
          />
          <PodSection columnAlign alignTop>
            <ProductCustomOptions itemId={pod.itemId} />
            <ProductSample itemId={pod.itemId} />
            <SuperSkuMiniSwatches
              itemId={pod.itemId}
              onChange={pod.onChange}
              onHover={pod.onSSKUHover}
            />
            <ProductServiceAddOns itemId={pod.itemId} />
            <PodSpacer minHeight="60px" disable={pod.productSubType === 'HDQC'}>
              <Price
                itemId={pod.itemId}
                large={false}
                storeId={storeId}
                displayEachUom={false}
                onSavingsCenterToggle={pod.onSavingsCenterToggle}
                hideForProductTypes={['HDQC']}
              />
            </PodSpacer>
            <ProductRating itemId={pod.itemId} />
            <PodSpacer minHeight="21px">
              <ProductIdentifier itemId={pod.itemId} type="model" />
            </PodSpacer>
            <PodSpacer padding={['TOP', 'BOTTOM']}>
              <ProductHeader
                brand="above"
                itemId={pod.itemId}
                brandTitleMaxLine={4}
                onClick={onClick}
              />
            </PodSpacer>
            <PodSpacer padding={['TOP']}>
              <KeyProductFeatures
                hideImage
                storeId={storeId}
                itemId={pod.itemId}
                maxfeatures={5}
                simple
                oneColumnGrid
              />
            </PodSpacer>
          </PodSection>
          <PodFooter>
            <PodSpacer minHeight="124px" disable={pod.productSubType === 'HDQC'}>
              <FulfillmentPodStore itemId={pod.itemId} storeId={storeId} hideForChooseYourOptions />
              <FulfillmentPodShipping itemId={pod.itemId} storeId={storeId} />
            </PodSpacer>
            <ProductSeeSimilarItems
              itemId={pod.itemId}
              position={itemRecsIndex}
              productPodRef={pod.ref}
              storeId={storeId}
            />
            <PodSpacer minHeight="40px" padding={['TOP']}>
              <ProductATC
                itemId={pod.itemId}
                storeId={storeId}
                checkGeneric
                outline
                hasInStoreFilter={hasInStoreFilter}
              />
              <NonBuyableQuoteCenter itemId={pod.itemId} checkForProductSubType={['HDQC']} />
            </PodSpacer>
            <ProductCompare
              itemId={pod.itemId}
              onSelectedForCompare={onSelectedForCompare}
              onCompare={onCompare}
              selectedForCompare={selectedForCompare}
            />
          </PodFooter>
        </>
      )}
    />
  );
};

CustomProductPod.propTypes = {
  itemId: PropTypes.string.isRequired,
  storeId: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired,
  onHover: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  hoverDelay: PropTypes.number.isRequired,
  onSelectedForCompare: PropTypes.func.isRequired,
  onCompare: PropTypes.func.isRequired,
  itemRecsIndex: PropTypes.number.isRequired,
  selectedForCompare: PropTypes.arrayOf(PropTypes.string).isRequired,
  hasInStoreFilter: PropTypes.bool.isRequired
};

CustomProductPod.dataModel = extend(
  ProductPod,
  ProductImage,
  ProductServiceAddOns,
  Favorite,
  Price,
  SuperSkuMiniSwatches,
  ProductATC,
  ProductRating,
  ProductCompare,
  ProductSample,
  ProductHeader,
  ProductIdentifier,
  ProductBadge,
  ProductSponsored,
  FulfillmentPodStore,
  FulfillmentPodShipping,
  ProductCustomOptions,
  KeyProductFeatures,
  ProductSeeSimilarItems,
  NonBuyableQuoteCenter
);
